import {Attachment} from '../../../core/models';

export class Laptop {
  id: string;
  brand: string;
  cost: number;
  description: string;
  image: Attachment;
}
